import React, { useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isHomePage = location.pathname === '/';
  const timeoutRef = useRef(null);

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  // Handle scroll to contact section after navigation
  useEffect(() => {
    if (isHomePage && location.state?.scrollToContact) {
      timeoutRef.current = setTimeout(() => {
        const contactSection = document.getElementById('contact-section');
        if (contactSection) {
          contactSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [isHomePage, location.state]);

  const handleConnectClick = () => {
    if (isHomePage) {
      // If already on home page, just scroll to contact section
      const contactSection = document.getElementById('contact-section');
      if (contactSection) {
        contactSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } else {
      // Navigate to home page with state to trigger scroll
      navigate('/', { state: { scrollToContact: true } });
    }
  };

  return (
    <footer className="footer">
      <div className="footer-banner">
        {!isHomePage && (
          <div className="footer-banner-content">
            <p className="footer-banner-text">Ready to explore a world of branding and packaging solutions?</p>
            <button className="footer-banner-button" onClick={handleConnectClick}>Let's Connect</button>
          </div>
        )}
      </div>
      <div className="footer-content">
        <div className="footer-content-spacer"></div>
        {/* Section 1: Logo and Navigation */}
        <div className="footer-section">
          <div className="footer-section-content">
            <div className="footer-left">
              <img 
                src="/parksons-logo-1-190x44.png" 
                alt="Parksons Packaging Ltd" 
                className="footer-logo"
              />
            </div>
            <div className="footer-right">
              <nav className="footer-nav">
                <Link to="/about" className="footer-nav-link">About</Link>
                <Link to="/markets" className="footer-nav-link">Our Markets</Link>
                <Link to="/innovation" className="footer-nav-link">Our Products</Link>
              </nav>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="footer-divider"></div>

        {/* Section 2: Tagline and Legal Links */}
        <div className="footer-section">
          <div className="footer-section-content">
            <div className="footer-left">
              <p className="footer-tagline">Parksons Is A Global Packaging Solutions Provider</p>
            </div>
            <div className="footer-right">
              <div className="footer-legal-links">
                <Link to="/disclaimer" className="footer-legal-link">Disclaimer</Link>
                <Link to="/privacy" className="footer-legal-link">Privacy Policy</Link>
                <Link to="/terms" className="footer-legal-link">Terms of Use</Link>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="footer-divider"></div>

        {/* Section 3: Copyright */}
        <div className="footer-section">
          <div className="footer-section-content">
            <div className="footer-left">
              <p className="footer-copyright">© Parksons Packaging Ltd. 2023. All Rights Reserved</p>
            </div>
            <div className="footer-right">
              {/* Empty right side */}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
